module.exports = __webpack_public_path__ + "img/bad_smell.83aca9f5.svg";